import ParsingAvito from './ParsingAvito'
import WithParsing from 'containers/WithParsing'

export default WithParsing(ParsingAvito)
